<template>
  <van-nav-bar
      title="证件种类"
      left-text="返回"
      right-text="添加"
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
  />
  <van-list v-model:loading="loading" :finished="finished">
    <van-cell
        v-for="item in list"
        :key="item.id"
        :title="item.name"
    >
      <template #right-icon>
        <van-button icon="edit" text="编辑" size="mini"
                    plain type="success" @click="clickEvent(item)">
        </van-button>
        <b style="width: 20px">|</b>
      </template>
      <template #extra>
        <van-button icon="arrow" size="mini" type="primary" plain
                    :to="{ path: '/addTrainProject', query: { parent: item.id } }"
        >
          作业类别
        </van-button>
      </template>
    </van-cell>
  </van-list>
  <!--  <van-list v-model:loading="loading" :finished="finished">
      <van-cell
        is-link
        clickable
        v-for="item in list"
        :to="{ path: '/addTrainProject', query: { parent: item.id } }"
        :key="item.id"
        :title="item.name"
        :label="'培训费' + item.money + '元 '"
      />
    </van-list>-->

  <van-dialog
      @confirm="addSpeciesId"
      v-model:show="show"
      title="添加证件种类"
      show-cancel-button
  >
    <van-cell-group>
      <van-field
          v-model="SpeciesName"
          label="证件种类名称"
          placeholder="请输入证件种类名称"
      />
      <!--      <van-field v-model="money" type="digit" label="培训费用" />-->
    </van-cell-group>
  </van-dialog>

  <van-dialog
      @confirm="editSpeciesId"
      v-model:show="showEdit"
      title="修改证件种类"
      show-cancel-button
  >
    <template #title>
      <div style="display: flex;flex-direction: column;width: 100%;align-items: center;justify-content: center">
        <b>修改证件种类</b>
        <van-button size="mini" icon="delete" plain type="danger" @click="deleteSpecies"
                    text="点击删除证件种类"></van-button>
      </div>

    </template>
    <van-cell-group>
      <van-field
          v-model="nowSelectSpecies.name"
          label="证件种类名称"
          placeholder="请输入证件种类名称"
      />
      <!--      <van-field v-model="money" type="digit" label="培训费用" />-->
    </van-cell-group>
  </van-dialog>
</template>

<script>
import {useRouter} from "vue-router";
import {onMounted, reactive, ref, toRefs} from "vue";
import {Dialog, Notify} from "vant";
import axios from "../../api/http";

export default {
  name: "AddTrainSpecies",
  setup() {
    const router = useRouter();
    const show = ref(false);
    const SpeciesName = ref("");
    const money = ref(0);

    function onClickLeft() {
      router.back();
    }

    const listDemo = reactive({
      list: [],
      loading: false,
      finished: false
    });

    function onClickRight() {
      show.value = true;
    }

    const getAllSpeciesId = () => {
      axios.get("/api/RegisterInfo/GetTrainSpecies").then(res => {
        console.log(res.data);
        listDemo.finished = true;
        listDemo.list = res.data;
      });
    };

    function addSpeciesId() {
      console.log(SpeciesName.value);
      if (SpeciesName.value == "" || SpeciesName.value == undefined) {
        Notify({type: "danger", message: "证件种类名称不可为空"});
        return;
      }
      axios
          .post(
              "/api/addTrainInformation/addTrainSpecies/" +
              SpeciesName.value +
              "/money/" +
              money.value
          )
          .then(res => {
            console.log(res.data);
            SpeciesName.value = "";
            money.value = 0;
            getAllSpeciesId();
          });
    }


    const showEdit = ref(false)
    let nowSelectSpecies = ref({
      id: undefined,
      name: undefined,
    })

    function clickEvent(speciesId) {
      nowSelectSpecies.value.id = speciesId.id;
      nowSelectSpecies.value.name = speciesId.name;
      showEdit.value = true;
    }

    function editSpeciesId() {
      if (nowSelectSpecies.value.id === "" || nowSelectSpecies.value.id === undefined) {
        Notify({type: "danger", message: "证件种类未找到,请重新编辑"});
        return;
      }

      if (nowSelectSpecies.value.name === "" || nowSelectSpecies.value.name === undefined) {
        Notify({type: "danger", message: "证件种类名称不可为空"});
        return;
      }

      axios
          .post(
              "/api/addTrainInformation/editTrainSpecies/" +
              nowSelectSpecies.value.id +
              "/name/" +
              nowSelectSpecies.value.name
          )
          .then(res => {
            console.log(res.data);
            getAllSpeciesId();
          });
    }

    function deleteSpecies() {
      if (nowSelectSpecies.value.id === "" || nowSelectSpecies.value.id === undefined) {
        Notify({type: "danger", message: "证件种类未找到,请重新编辑"});
        return;
      }
      Dialog.confirm({
        title: "删除警告",
        message: "是否确认删除【" + nowSelectSpecies.value.name + "】",
      }).then(() => {
        axios
            .post(
                "/api/addTrainInformation/deleteTrainSpecies/" +
                nowSelectSpecies.value.id
            )
            .then(res => {
              console.log(res.data);
              showEdit.value = false
              nowSelectSpecies.value.id = undefined
              nowSelectSpecies.value.name = undefined
              getAllSpeciesId();
            });
      }).catch(() => {
        // on cancel
      });
    }


    onMounted(() => {
      getAllSpeciesId();
    });

    return {
      onClickLeft,
      onClickRight,
      router,
      ...toRefs(listDemo),
      addSpeciesId,
      show,
      SpeciesName,
      money,
      showEdit,
      nowSelectSpecies,
      clickEvent,
      editSpeciesId,
      deleteSpecies
    };
  }
};
</script>
